import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FormControl, FormGroup, UntypedFormControl } from '@angular/forms';

import { DATE_YMD, PROJECT_CARRIER_MAP_STATUS } from 'cargo-chief-commons';

@Component({
	selector: 'app-engage-carriers-dialog',
	templateUrl: './engage-carriers-dialog.component.html',
	styleUrls: ['./engage-carriers-dialog.component.scss'],
})
export class EngageCarriersDialogComponent implements OnInit {
	showRateForm: boolean = true;
	showNotes: boolean = true;
	isFormSubmitted: boolean = false;
	submitButtonText: string = 'Engage';
	dialogHeader: string = 'Add note and rate';
	hideEngageCarriersDialog: boolean = false;
	initialDialogSetting: boolean = false;

	carrierRespondedAt = new UntypedFormControl(new Date());
	rateDetailsForm: FormGroup = new FormGroup({
		desiredPrice: new FormControl('', []),
		carrierRespondedAt: new FormControl('', []),
		status: new FormControl(PROJECT_CARRIER_MAP_STATUS.IN_PROGRESS, []),
	});

	constructor(
		public dialogRef: MatDialogRef<EngageCarriersDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: any
	) {
		this.showRateForm = this.dialogData.showRateForm;
		this.showNotes = this.dialogData.showNotes;
		if (this.dialogData.submitButtonText) {
			this.submitButtonText = this.dialogData.submitButtonText;
		}
		if (this.dialogData.dialogHeader) {
			this.dialogHeader = this.dialogData.dialogHeader;
		}
	}

	ngOnInit() {}

	submitForm(): void {
		this.isFormSubmitted = true;
		this.rateDetailsForm.patchValue({
			carrierRespondedAt: DATE_YMD(this.carrierRespondedAt.value),
		});
		let payload = Object.assign({}, this.rateDetailsForm.value);
		payload.desiredPrice = Number(payload.desiredPrice) * 100;

		if (this.initialDialogSetting != this.hideEngageCarriersDialog) {
			payload.hideModal = this.hideEngageCarriersDialog;
		}
		payload['carrierProvidingRate'] = false;
		payload['carrierIDs'] = this.dialogData.carrierIds;
		if (this.dialogData.projectCarrierMapsList) {
			payload['projectCarrierMapsList'] = this.dialogData.projectCarrierMapsList;
		}
		this.closeDialog(payload);
	}

	closeDialog(data: any): void {
		this.dialogRef.close(data);
	}
}
